
import { PropTypes } from 'prop-types';
import { MdOutlineKeyboardDoubleArrowRight } from 'react-icons/md';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const FooterItem = ({ item }) => {
    return (
        <div className='flex flex-col  gap-4  w-full  lg:items-start text-white'>
            <span className='uppercase text-white font-bold flex gap-2  md:justify-start w-44 items-center  whitespace-nowrap 2xl:text-lg'>{item?.title}<MdOutlineKeyboardDoubleArrowRight className={`${item?.title === "" ? "hidden" : 'block'}`} /></span>
            <ul className='flex flex-col list-none  gap-4 text-gray-300 md:w-44'>
                {
                    item?.items.map((item1, index) => (
                        <motion.li
                            initial={{ x: 0, opacity: 0.8, scale: 1 }}
                            whileHover={{
                                x: 5,
                                opacity: 1,
                                scale: 1.02

                            }}
                            transition={{
                                type: 'spring',
                                stiffness: 300,
                                damping: 20

                            }}
                            key={index} className='group cursor-pointer text-xs 2xl:text-sm'>
                            {
                                item1?.link?.includes("http") ? <a href={item1.link} className=' flex  gap-2 items-center' target="_blank" rel="noreferrer">{item1.name}</a> : <Link to={item1.link} className=' flex  gap-2 items-center'>{item1.name}</Link>
                            }
                        </motion.li>
                    ))
                }
            </ul>
        </div>
    )
}

FooterItem.propTypes = {
    item: PropTypes.object
}
export default FooterItem